import UserManager from "../userManager";
import Api from "services2/Api";

export type InteractionContext = {
  datetime: Date;
  type: string;
  identity: string;
  impersonatingIdentity: string | null;
  domain: string;
  application: string;
  module: string;
  action: string;
  context?: {}[];
};

export const baseUserInteraction: InteractionContext = {
  datetime: new Date(),
  type: "User",
  identity: "PLACEHOLDER",
  impersonatingIdentity: null,
  domain: "Zenith",
  application: "Zenith Mosaic",
  module: "PLACEHOLDER",
  action: "PLACEHOLDER",
};

export const logInteractionModel = async (interaction: InteractionContext) => {
  await Api.post("/api/system/interaction", interaction);
};

export const logInteraction = async (
  id: number,
  module: string,
  action: string,
  context: {}[]
) => {
  var renamedModule = module == "Fund" ? "Products" : module;

  const user = await UserManager.getUser();

  if (user && id) {
    const data = {
      Module: renamedModule,
      Action: action,
      Context: context,
    };

    await Api.post("/api/system/interaction", data);
  }
};

export const logInteractionWoContext = async (
  module: string,
  action: string
) => {
  var renamedModule = module == "Fund" ? "Products" : module;

  const data = {
    Module: renamedModule,
    Action: action,
    Context: [],
  };
  await Api.post("/api/system/interaction", data);
};

export const LogViewListInteraction = async (path: string) => {
  switch (path) {
    case "/mosaic/insights":
      logInteractionWoContext("Insights", "View List");
      break;
    case "/mosaic/products":
    case "/mosaic/investments":
      logInteractionWoContext("Products", "View List");
      break;
    case "/mosaic/portfolios":
      logInteractionWoContext("Portfolios", "View List");
      break;
    case "/mosaic/chant-west-reports":
      logInteractionWoContext("Chant West Research", "View List");
      break;
    case "/mosaic/lifetime-products":
      logInteractionWoContext("Lifetime Products", "View List");
      break;
    case "/mosaic/super-funds":
      logInteractionWoContext("Super Funds", "View List");
      break;
  }
};
